import React, { FC } from 'react';
import { Header } from './Layouts/header';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';

const UnmemberRoot: FC = () => {
  return (
    <div>
      <Header user={null} />

      <Box style={{ padding: '60px 0px 0px 20px' }}>
        <Box style={{ padding: '0px 0px' }}>
          <Outlet />
        </Box>

        <footer></footer>
      </Box>
    </div>
  );
};

export default UnmemberRoot;
